import { useState } from 'react';
import UserSearchField from './UserSearchField';
import ProfileDefaultImage from '../../../images/profileDefault.png';
import { UserType } from '../../../enums/UserType';

export const JobFindUserPlaceholderV2 = ({
  title,
  style,
  userType,
  onSelectUser,
  heightEnabled,
  inputStyle,
  buttonStyle,
}) => {
  const [searchUser, setSearchUser] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 20,
        ...style,
      }}
    >
      <img
        src={ProfileDefaultImage}
        alt="tooth"
        className="card-img-top mt-2 mb-2"
        style={{
          objectFit: 'cover',
          width: '100px',
          height: '100px',
          borderRadius: 50,
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
        }}
      />
      {searchUser ? (
        <UserSearchField
          user_type={userType}
          onSelectUser={(user) => {
            setSearchUser(false);
            onSelectUser(user);
          }}
          placeholder={userType === UserType.HYG ? 'Type a Hygienist Name' : 'Type a Dentist Name'}
          heightEnabled={heightEnabled}
          style={{ width: 'auto', minWidth: 200 }}
          inputStyle={{ margin: 0, ...inputStyle }}
        />
      ) : (
        <button
          type="button"
          className="btn btn-light border border-info mb-2 mt-2"
          style={{
            height: 90,
            width: 200,
            borderRadius: 11,
            marginBottom: 10,
            ...buttonStyle,
          }}
          onClick={() => setSearchUser(true)}
        >
          {title}
        </button>
      )}
    </div>
  );
};
